import * as React from "react";

import { AppState, Actions, PanelState, store, IPageState } from '../appredux';
import { connect } from 'react-redux';
import { bookService, dostepnoscPokoju, grafikOgolnyPokoje, ObiectRoomNumer, ObiectRoomRodzaj, RodzPokoiInfo, webRoom, } from '../api';
import { Grid, Paper, Card } from '@material-ui/core';
import RoomCard from './Room';

import { Theme, withStyles, WithStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { formatDate, sendErrorLog, themeExist, themeSelect } from "./common/helpers";
import CONFIG from "../cfg/config";
import { fontSelect } from "../fonts";
import { Trans, WithTranslation, TransProps, withTranslation } from 'react-i18next';

import FormularzImplementacja from './form/FormularzImplementacja';
import FormularzImplementacjaStary from './form/FormularzImplementacjaStary';
import OknaPlatnosci from "./payment/OknaPlatnosci";
import Loader from "app/common/loader/Loader";

//PM 2021-11-16
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface BrowseProps {
  windowWidth: number,

  page: IPageState,
  //detailsClick? : any,
  //reservClick? : any,
  grafikNumery: ObiectRoomNumer[],
  rooms: RodzPokoiInfo[],
  grafikRodzaje: ObiectRoomRodzaj[],
  roomsOld: webRoom[],
  grafik: grafikOgolnyPokoje[],
  dataOd: string,
  roomsDetailsList: dostepnoscPokoju[],
}

//PM 2021-11-16
//usuniecie nieuzywanych pol
type BrowseState = {
}

const GREEN_BORDER = "1px solid #458B00"

class Browse extends React.Component<BrowseProps & WithTranslation & WithStyles<typeof styles>, BrowseState>  {

  //PM 2021-11-16
  //usuniecie nieuzywanych pol
  constructor(props: BrowseProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    this.state = {
    }
  }

  selectRoom = (id: string) => {
    store.dispatch(
      Actions.pageState.selectRoom(PanelState.psDetails, id)
    )
  }

  selectComponent() {
    if (this.props.page.state === PanelState.psBrowse) {
      return (
        <></>
      )
      // } else if (this.props.page.state==PanelState.psDetails) {
      //   return(
      //     // <Details roomCategory={ this.props.page.selectedRoom }  /> 
      //   )
    } else if (this.props.page.state === PanelState.psUser && (CONFIG.grafikiRodzaj == "0" || CONFIG.grafikiRodzaj === "3")) {
      return (
        <FormularzImplementacjaStary/>
      )
    } else if (this.props.page.state === PanelState.psUser) {
      return (
        <FormularzImplementacja />
      )
    } else if (this.props.page.state === PanelState.psReservPending) {
      return (
        <Loader />
      )
    }
  }



  // async getRoomsData() {
  //   try {
  //     let res: webRooms = await roomsService.getRooms({
  //       hotelId: CONFIG.hotelID,
  //       aOperatorId: Number(sessionStorage.getItem("operator_id")),
  //       aDomena: this.props.page.lang
  //     })
  //     let storeRooms: webRoom[]
  //     storeRooms = []
  //     for (const room1 of res.result) {
  //       storeRooms.push({ ...room1 })
  //     }
  //     store.dispatch(Actions.pageState.updateRooms(storeRooms));
  //     this.setState({
  //       lang: this.props.page.lang,
  //       dateFrom: this.props.page.dateFrom,
  //       dateTo: this.props.page.dateTo
  //     });
  //   } catch (error) {
  //     console.error
  //   }
  // }


  // async getGrafik() {
  //   console.log('Pobieram grafik')
  //   const max_ilosc_dni_min : number = Math.max.apply(Math, this.props.page.rooms.map((room : webRoom) => room.ilosc_dni_min));
  //   const roznica_dni : number = this.datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo));
  //   const o_ile_dluzszy_termin : number = max_ilosc_dni_min - roznica_dni;
  //   let date = new Date(new Date(this.props.page.dateTo).setDate(new Date(this.props.page.dateTo).getDate() - 1 + (o_ile_dluzszy_termin > 0? o_ile_dluzszy_termin : 0)));

  //   try {
  //     let res: grafik = await grafikOgolny.getRooms({
  //       hotelId: CONFIG.hotelID,
  //       aOperatorId: Number(sessionStorage.getItem("operator_id")),
  //       aManagerOK: 0,
  //       aDataOd: this.props.page.dateFrom,
  //       aDataDo: daysFromDate(date)
  //     })
  //     let tablica: grafikOgolnyPokoje[] = [];
  //     for (let i = 0; i < res.result.length; i++)
  //       tablica.push(res.result[i]);
  //     store.dispatch(Actions.pageState.updateGrafik(tablica));
  //   } catch (error) {
  //     console.error
  //   }

  // }

  // componentDidMount() {
  //   //this.getRoomsData();
  // }
  

  componentDidUpdate(prevProps: BrowseProps) {
    // console.log(this.props.page.podstrona)
    // console.log(document.getElementById("fab"))
    // if(this.props.page.podstrona === 0 && prevProps.page.podstrona > 1  && this.props.rooms.length !== prevProps.rooms.length){
    //   console.log("lol")
    //   setTimeout(() => {
    //     window.scrollTo({ top: 0 });
    //   }, 100);
      
    // }

    //if(prevProps.page.rooms.length === 0 && this.props.page.rooms)
    //  this.getGrafik();
    // if(prevProps.page.lang !== this.props.page.lang ){
    //   this.getRoomsData();
    //   //this.getGrafik();
    // } 
    // else if(prevProps.page.state==PanelState.psReservPending && this.props.page.state == PanelState.psBrowse){
    //   //this.getRoomsData();
    //   this.getGrafik();
    // } 
  }

  //PM 2021-11-16
  //key={roomNumer.pokoj}
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render = () => {
    const { classes } = this.props;
    const t = this.props.t
    // const max_ilosc_dni_min: number = Math.max.apply(Math, this.props.page.rooms.map((room: RodzPokoiInfo) => Number(room.minIloscDni)));
    // const min_ilosc_dni_min: number = Math.min.apply(Math, this.props.page.rooms.map((room: RodzPokoiInfo) => Number(room.minIloscDni)));
    // const roznica_dni: number = datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo));

    // if (min_ilosc_dni_min !== Infinity) {
    //   if (this.props.page.ilosc_dni_min !== min_ilosc_dni_min
    //     || this.props.page.ilosc_dni_min > min_ilosc_dni_min)
    //     store.dispatch(Actions.pageState.setIloscDniMin(min_ilosc_dni_min));
    //   //console.log(roznica_dni)
    //   if (roznica_dni < min_ilosc_dni_min)
    //     store.dispatch(Actions.pageState.setDateTo(minDaysLater(this.props.page.dateFrom, min_ilosc_dni_min)));
    // }

    let rooms: JSX.Element[] = [];

    if (CONFIG.grafikiRodzaj === "2"){
      let roomsRodzaj = this.props.grafikNumery.filter(x => x.typ === 2)
      roomsRodzaj.forEach((roomNumer, index) => {

        const pokoje_dostepne = this.props.grafikNumery
          .filter(dzien => dzien.pokoj === roomNumer.pokoj);
        const room1 = this.props.rooms.find(r => r.rodzPokoi === roomNumer.rodzPokoi.trim());

        if (room1) {
          // if (roznica_dni >= Number(room1.minIloscDni)
          //   && roznica_dni < max_ilosc_dni_min)
          //   pokoje_dostepne = pokoje_dostepne.slice(0, roznica_dni);

          //let pokoje_dostepne2 = pokoje_dostepne.find(dzien => dzien.iloscW >= 1);
          let pokoje_dostepne2 = false
          if (pokoje_dostepne.length > 0)
            pokoje_dostepne2 = pokoje_dostepne[1].iloscW >= 1

          //let kolorTla = roomsRodzaj.length <= 8 ? "0" :  
          let kolorTla = this.props.windowWidth < 1000 &&  index % 2  === 0 || (this.props.windowWidth >= 1000 && (index % 4  === 2 || index % 4  === 3)) ? GREEN_BORDER: "0"

          rooms.push(
            <Grid
              key={roomNumer.pokoj} item
              className={classes.break}
              style={{ padding: this.props.windowWidth > 600 && this.props.windowWidth < 1000 ? "0px" : this.props.windowWidth > 600 ? (index % 2 === 0 ? "0px 6px 0px 0px" : "0px 0px 0px 6px") : "0px 0px" }}
            >
              <RoomCard
                room={{
                  cena: room1.cena,
                  galleryRodzPokoi: `2-${roomNumer.pokoj}`,
                  id: room1.id,
                  iloscMiejsc: room1.iloscMiejsc,
                  info: room1.info,
                  minIloscDni: room1.minIloscDni,
                  opis: roomNumer.dana1,
                  pokoj: roomNumer.pokoj,
                  rodzPokoi: room1.rodzPokoi.trim(),
                  ktoraCenaOpis: room1.ktoraCenaOpis

                }}
                key={Number(roomNumer.pokoj)}
                pokoje_dostepne={pokoje_dostepne2}
                windowWidth={this.props.windowWidth}
                //kolorTla={kolorTla} />
                borderLeft={kolorTla} />
            </Grid>
          )
        }
      })
        //
      //if(roomsRodzaj.length % 2 !== 0  && this.props.windowWidth >= 1000){ // mz 2022-06-15 dodajemy dummy pokój dla nieparzystych
      if( roomsRodzaj.length % 2 !== 0  && this.props.windowWidth >= 1000 || this.props.page.podstrona > 0 && this.props.windowWidth >= 1000){ // zawsze dodajemy pokoj 
        let kolorTla = roomsRodzaj.length % 4  === 3  ? GREEN_BORDER: "0"
        rooms.push(
          <Grid
            key={9999} item
            className={classes.break}
            style={{ padding: this.props.windowWidth < 1000 ? "0px" : roomsRodzaj.length % 2 !== 0 ? "0px 0px 0px 6px" : "0px 6px 0px 0px" }}
            >
            <RoomCard
              room={{
                cena: '-1',
                galleryRodzPokoi: `startowe`,
                id: '9999',
                iloscMiejsc: '-1',
                info: 'info',
                minIloscDni: '-1',
                opis: t('Welcome'),
                pokoj: 0,
                rodzPokoi: '-1',
                ktoraCenaOpis: '-1'
              }}
              key={9999}
              pokoje_dostepne={false}
              windowWidth={this.props.windowWidth} 
              //kolorTla={kolorTla}/>
              borderLeft={kolorTla} />
          </Grid>
        )
      }

    }
    else if (CONFIG.grafikiRodzaj === "1"){
      this.props.rooms.forEach((room1, index) => {
        const pokoje_dostepne = this.props.grafikRodzaje
          .filter((dzien) =>
            dzien.rodzPokoi.trim() === room1.rodzPokoi.trim());

        // if (roznica_dni >= Number(room1.minIloscDni)
        //   && roznica_dni < max_ilosc_dni_min)
        //   pokoje_dostepne = pokoje_dostepne.slice(0, roznica_dni);


        //let pokoje_dostepne2 = pokoje_dostepne.find((dzien) => dzien.iloscW >= 1);
        let pokoje_dostepne2 = false
        if (pokoje_dostepne.length > 0)
          pokoje_dostepne2 = pokoje_dostepne[1].iloscW >= 1

        let kolorTla = this.props.windowWidth < 1000 &&  index % 2  === 0 || (this.props.windowWidth >= 1000 && (index % 4  === 2 || index % 4  === 3)) ? GREEN_BORDER: "0"

        rooms.push(
          <Grid
            key={room1.id} item
            className={classes.break}
            style={{ padding: this.props.windowWidth > 600 && this.props.windowWidth < 1000 ? "0px" : this.props.windowWidth > 600 ? (index % 2 === 0 ? "0px 6px 0px 0px" : "0px 0px 0px 6px") : "0px 0px" }}
          >
            <RoomCard
              room={{
                cena: room1.cena,
                galleryRodzPokoi: `1-${room1.rodzPokoi}`,
                id: room1.id,
                iloscMiejsc: room1.iloscMiejsc,
                info: room1.info,
                minIloscDni: room1.minIloscDni,
                opis: room1.opis,
                pokoj: 0,
                rodzPokoi: room1.rodzPokoi,
                ktoraCenaOpis: room1.ktoraCenaOpis
              }}
              key={Number(room1.id)}
              pokoje_dostepne={pokoje_dostepne2}
              windowWidth={this.props.windowWidth}
              //kolorTla={kolorTla} />
              borderLeft={kolorTla} />
          </Grid>
        )
      })

      //if(this.props.rooms.length % 2 !== 0  && this.props.windowWidth >= 1000){ // mz 2022-06-15 dodajemy dummy pokój dla nieparzystych
      if( this.props.rooms.length % 2 !== 0  && this.props.windowWidth >= 1000 || this.props.page.podstrona > 0 && this.props.windowWidth >= 1000){ // zawsze dodajemy pokoj 
      let kolorTla = this.props.rooms.length % 4  === 3  ? GREEN_BORDER: "0"
        rooms.push(
          <Grid
            key={9999} item
            className={classes.break}
            style={{ padding: this.props.windowWidth < 1000 ? "0px" : this.props.rooms.length % 2 !== 0 ? "0px 0px 0px 6px" : "0px 6px 0px 0px" }}
            >
            <RoomCard
              room={{
                cena: '-1',
                galleryRodzPokoi: `startowe`,
                id: '9999',
                iloscMiejsc: '-1',
                info: 'info',
                minIloscDni: '-1',
                opis: t('Welcome'),
                pokoj: 0,
                rodzPokoi: '-1',
                ktoraCenaOpis: '-1'
              }}
              key={9999}
              pokoje_dostepne={false}
              windowWidth={this.props.windowWidth} 
              //kolorTla={kolorTla}/>
              borderLeft={kolorTla} />
          </Grid>
        )
      }

    }
    else if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3"){
      this.props.roomsOld.forEach(async (room1, index) => {
        const pokoje_dostepne = this.props.grafik
          .filter((dzien: grafikOgolnyPokoje) =>
            dzien.rodz_pokoi === room1.rodz_pokoi);

        // if (roznica_dni >= Number(room1.minIloscDni)
        //   && roznica_dni < max_ilosc_dni_min)
        //   pokoje_dostepne = pokoje_dostepne.slice(0, roznica_dni);

        let ktoraCena = room1.ktora_cena === 0
          ? t('Room-day')
          : room1.ktora_cena === 1
            ? t('Person-day') : ""

        //let pokoje_dostepne2 = pokoje_dostepne.find((dzien: grafikOgolnyPokoje) => dzien.pokoje_dostepne >= 1);
        let pokoje_dostepne2 = false
        if (pokoje_dostepne.length > 0)
          pokoje_dostepne2 = pokoje_dostepne[0].pokoje_dostepne >= 1

        let res_dost = null;
        if(this.props.roomsDetailsList)
          res_dost = this.props.roomsDetailsList.find(element => element.pokoj === room1.www_rodz_pokoi_id);

        //console.log('res_dost = ' + (res_dost ? (res_dost != null ? String(res_dost.cena_pokoj) : 'blad') : 'blad'))
        
        let kolorTla = this.props.windowWidth < 1000 &&  index % 2  === 0 || (this.props.windowWidth >= 1000 && (index % 4  === 2 || index % 4  === 3)) ? GREEN_BORDER: "0"

        rooms.push(
          <Grid
            key={room1.www_rodz_pokoi_id} item
            className={classes.break}
            style={{ padding: this.props.windowWidth > 600 && this.props.windowWidth < 1000 ? "0px" : this.props.windowWidth > 600 ? (index % 2 === 0 ? "0px 6px 0px 0px" : "0px 0px 0px 6px") : "0px 0px" }}
          >
            <RoomCard
              room={{
                cena: res_dost ? String(res_dost.cena_pokoj) : String(room1.cena_pokoj),
                galleryRodzPokoi: `0-${room1.www_rodz_pokoi_id}`,
                id: room1.www_rodz_pokoi_id,
                iloscMiejsc: String(room1.ilosc_miejsc),
                info: room1.info,
                minIloscDni: String(room1.ilosc_dni_min),
                opis: room1.opis,
                pokoj: 0,
                rodzPokoi: room1.rodz_pokoi,
                ktoraCenaOpis: ktoraCena
              }}
              key={Number(room1.www_rodz_pokoi_id)}
              pokoje_dostepne={pokoje_dostepne2}
              windowWidth={this.props.windowWidth}
              podstrona={room1.podstrona_nr}
              //kolorTla={kolorTla} />
              borderLeft={kolorTla} />
          </Grid>
        )
      })

      //if(this.props.roomsOld.length % 2 !== 0  && this.props.windowWidth >= 1000){ // mz 2022-06-15 dodajemy dummy pokój dla nieparzystych
      if( this.props.roomsOld.length % 2 !== 0  && this.props.windowWidth >= 1000 || this.props.page.podstrona > 0 && this.props.windowWidth >= 1000){ // zawsze dodajemy pokoj 
      let kolorTla = this.props.roomsOld.length % 4  === 3  ? GREEN_BORDER: "0"
        rooms.push(
          <Grid
            key={9999} item
            className={classes.break}
            style={{ padding: this.props.windowWidth < 1000 ? "0px" : this.props.roomsOld.length % 2 !== 0 ? "0px 0px 0px 6px"  : "0px 6px 0px 0px" }}
            >
            <RoomCard
              room={{
                cena: '-1',
                galleryRodzPokoi: `startowe`,
                id: '9999',
                iloscMiejsc: '-1',
                info: 'info',
                minIloscDni: '-1',
                opis: t('Welcome'),
                pokoj: 0,
                rodzPokoi: '-1',
                ktoraCenaOpis: '-1'
              }}
              key={9999}
              pokoje_dostepne={false}
              windowWidth={this.props.windowWidth} 
              //kolorTla={kolorTla}/>
              borderLeft={kolorTla} />
          </Grid>
        )
      }
    }
      // console.log(rooms)

      // if(rooms.length % 2 === 1 ){
      //   rooms.push(
      //   <Grid item  className={classes.break}
      //   style={{ padding: this.props.windowWidth > 600 && this.props.windowWidth < 1000 ? "0px" : this.props.windowWidth > 600 ? "0px 0px 0px 6px" : "0px 0px" }}>
      //     <Paper className={classes.paper} elevation={0} style={{width: '100%', height: '100%'}}>
      //       <Card
      //         elevation={4}
      //         style={{ background: "linear-gradient(to bottom, #ffffff, #f7f7f7)", width: '100%', height: 'calc(100% + -12px)' }}>

      //         {this.props.windowWidth > 1240 ?
      //           <Grid container  >
      //             <Grid item xs={12} style={{ paddingBottom: "0px", display: "flex" }}>
      //             </Grid>
      //           </Grid>
      //           :
      //           <Grid >
      //             <Grid item xs={12} style={{ paddingBottom: "0px" }}>
      //             </Grid>
      //           </Grid>}
      //       </Card>
      //     </Paper>
      //   </Grid>
      //   )
      // }

    //let roomsLeft = rooms.filter((room, index) => index % 2 === 0)
    //let roomsRight = rooms.filter((room, index) => index % 2 === 1)

    let textTheme = fontSelect(6, 2) as React.CSSProperties;
    let color = ""
    if (textTheme && Object.keys(textTheme).length !== 0) {
      color = textTheme.color as string
    }

    return (
      <>
      
  
      <Grid container className={classes.container} style={{ width: "100%" }}>

        {/* {themeExist(color) ? <>
          <MuiThemeProvider theme={themeSelect(color)}>
            <Grid item xs={12} sm={6} style={this.props.windowWidth > 600 ? { paddingRight: "4px" } : { paddingRight: "0px" }}>
              {roomsLeft}
            </Grid>
            <Grid item xs={12} sm={6} style={{ paddingLeft: this.props.windowWidth > 600 ? "4px" : "0px" }}>
              {roomsRight}
            </Grid>
          </MuiThemeProvider> </>
          :
          <><Grid item xs={12} sm={6} style={this.props.windowWidth > 600 ? { paddingRight: "4px" } : { paddingRight: "0px" }}>
            {roomsLeft}
          </Grid>
            <Grid item xs={12} sm={6} style={{ paddingLeft: this.props.windowWidth > 600 ? "4px" : "0px" }}>
              {roomsRight}
            </Grid></>} */}

        {themeExist(color) ? <>
          <MuiThemeProvider theme={themeSelect(color)}>
            {rooms}
          </MuiThemeProvider> </>
          :
          <>
            {rooms}
          </>}


      </Grid>
      {this.selectComponent()}
      <OknaPlatnosci/>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
  grafikNumery: state.pageState.grafikNumery,
  rooms: state.pageState.rooms,
  grafikRodzaje: state.pageState.grafikRodzaje,
  roomsOld: state.pageState.roomsOld,
  grafik: state.pageState.grafik,
  dataOd: state.pageState.dateFrom,
  roomsDetailsList: state.pageState.roomDetailsList,
});

// style
const styles = (theme: Theme) => ({
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  paper: {
    marginBottom: "1em",
  },
  primary: {
    color: theme.palette.primary.main,
    padding: "9px 14px 9px 0"
  },
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600
  },
  container: {
    margin: "0em",
  },
  break: {
    "@media (min-width: 1000px)": {
      flexGrow: 0,
      maxWidth: "50%",
      flexBasis: "50%"
    },
    flexGrow: 0,
    maxWidth: "100%",
    flexBasis: "100%"
  }

});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Browse)));
